import { useEffect, useState } from 'react';

const GoogleMapsStatus = () => {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const checkStatus = () => {
      const scriptTag = document.querySelector('script[src*="maps.googleapis.com"]');
      const scriptSrc = scriptTag?.src || '';
      const hasApiKeyInUrl = scriptSrc.includes('key=');
      
      const checks = {
        hasWindow: typeof window !== 'undefined',
        hasGoogle: !!window?.google,
        hasMaps: !!window?.google?.maps,
        hasPlaces: !!window?.google?.maps?.places,
        hasAutocomplete: !!window?.google?.maps?.places?.Autocomplete,
        apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ? 'Set' : 'Missing',
        scriptTag: !!scriptTag,
        scriptSrc: scriptSrc.substring(0, 100), // First 100 chars
        hasApiKeyInScript: hasApiKeyInUrl,
        scriptLoaded: scriptTag?.hasAttribute('data-loaded') || false,
      };

      const allGood = checks.hasGoogle && checks.hasMaps && checks.hasPlaces;
      
      let message = '';
      if (allGood) {
        message = 'Google Maps loaded successfully';
      } else if (!checks.scriptTag) {
        message = 'Script tag not found - Google Maps not loading';
      } else if (!checks.hasApiKeyInScript) {
        message = 'API key missing from script URL';
      } else if (checks.scriptTag && !checks.hasGoogle) {
        message = 'Script loaded but Google object not available - check API key restrictions';
      } else {
        message = 'Google Maps not fully loaded - check console for errors';
      }
      
      setStatus({
        ...checks,
        status: allGood ? 'ready' : 'error',
        message,
      });
    };

    // Check immediately
    checkStatus();

    // Check repeatedly to catch when it loads
    const interval = setInterval(checkStatus, 1000);
    const timer = setTimeout(() => clearInterval(interval), 30000); // Stop after 30 seconds

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, []);

  if (status === 'checking') {
    return (
      <div className="fixed bottom-4 left-4 bg-yellow-50 border border-yellow-200 rounded p-2 text-xs z-50">
        Checking Google Maps status...
      </div>
    );
  }

  if (status.status === 'ready') {
    return null; // Don't show anything if everything is working
  }

  return (
    <div className="fixed bottom-4 left-4 bg-red-50 border border-red-200 rounded p-3 text-xs z-50 max-w-xs">
      <div className="font-semibold text-red-800 mb-2">Google Maps Status</div>
      <div className="space-y-1 text-red-700">
        <div>API Key (env): {status.apiKey}</div>
        <div>Script Tag: {status.scriptTag ? 'Found' : 'Missing'}</div>
        <div>API Key in Script: {status.hasApiKeyInScript ? 'Yes' : 'No'}</div>
        <div>Google Object: {status.hasGoogle ? 'Yes' : 'No'}</div>
        <div>Maps API: {status.hasMaps ? 'Yes' : 'No'}</div>
        <div>Places API: {status.hasPlaces ? 'Yes' : 'No'}</div>
        {status.scriptSrc && (
          <div className="text-xs mt-2 break-all">Script URL: {status.scriptSrc}...</div>
        )}
      </div>
      <div className="mt-2 text-red-600 text-xs">
        {status.message}
      </div>
      <div className="mt-2 text-xs">
        <div className="font-semibold mb-1">Troubleshooting:</div>
        <div className="text-red-600 space-y-1">
          <div>1. Check browser console (F12) for errors</div>
          <div>2. Verify APIs are enabled in Google Cloud Console</div>
          <div>3. Ensure API key has no restrictions</div>
          <div>4. Restart dev server after .env changes</div>
        </div>
      </div>
    </div>
  );
};

export default GoogleMapsStatus;
